import React, { useState, useEffect } from "react";
import StepCard from "../../../../component/stepCard";
import PersonalInformation from "./personalInformation";
import "./userComponents.css";
import ServicesOffered from "./servicesOffered";
import AccountDetails from "./accountDetails";
import UploadDocument from "./uploadDocument";
import StoreDetails from "./storeDetails";
import ButtonNavigationBar from "../../../../component/buttonNavigationBar";
import { useNavigate } from "react-router-dom";
import {
  buildPersonalInfoPayload,
  buildStoreDetailsPayload,
  buildBankDetailsPayload,
} from "../../../../utils/buildUserPayload";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";

const steps = [
  "Owner",
  "Store Details",
  "Services Offered",
  "Bank Details",
  "Upload Documents",
];

function StoreManagement({
  handleProgress,
  user = "",
  mode = "create",
  id = "",
  userDetails,
  updateUser,
}) {
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [activeStepTitle, setActiveStepTitle] = useState("Owner");
  const [userPayload, setUserPayload] = useState({
    personal: {},
    storeDetails: {},
    serviceDetails: [],
    bankDetails: {},
    uploadDocs: [],
  });
  const [servicePayload, setServicePayload] = useState([]);

  useEffect(() => {
    if (userDetails) {
      setUserPayload({
        personal: userDetails?.personal || {},
        storeDetails: userDetails?.storeDetails || {},
        // serviceDetails: userDetails?.serviceDetails || [],
        bankDetails: userDetails?.bankDetails || {},
        uploadDocs: userDetails?.uploadDocs || [],
      });
    }
  }, [userDetails]);

  const stepHandler = (step) => {
    setActiveStep(step);
    setActiveStepTitle(steps[step]);
  };
  const handleNext = (formData, stepKey) => {
    if (stepKey !== "upload-doc") {
      const progress = Math.round(
        ((activeStep + 1) / (steps.length - 1)) * 100
      );
      setActiveStep((prev) => prev + 1);
      setActiveStepTitle(steps[activeStep + 1]);
      handleProgress(progress);
    }

    let newPayload;
    setUserPayload((prev) => {
      if (stepKey === "personal-info") {
        newPayload = { ...prev, personal: formData };
      } else if (stepKey === "store-details") {
        newPayload = { ...prev, storeDetails: formData };
      } else if (stepKey === "bank-details") {
        newPayload = { ...prev, bankDetails: formData };
      } else if (stepKey === "service_details") {
        newPayload = { ...prev, serviceDetails: formData };
      } else if (stepKey === "upload-doc") {
        newPayload = { ...prev, uploadDocs: formData };
      } else {
        newPayload = prev;
      }
      return newPayload;
    });
    if (
      mode === "edit" &&
      formData &&
      Object.keys(formData).length > 0 &&
      stepKey !== "service_details"
    ) {
      editUser(formData, stepKey);
    } else if (stepKey === "upload-doc") {
      Promise.resolve().then(() => {
        createUser(newPayload);
      });
    }
  };

  const handlePrevious = () => {
    if (activeStep !== 0) {
      const progress = Math.round(
        ((activeStep - 1) / (steps.length - 1)) * 100
      );
      setActiveStepTitle(steps[activeStep - 1]);
      setActiveStep((prev) => prev + -1);
      handleProgress(progress);
    }
  };

  const editUser = (formData, stepKey = null) => {
    let payloadData;
    switch (stepKey) {
      case "personal-info":
        payloadData = buildPersonalInfoPayload(formData);
        break;
      case "store-details":
      // case "service_details":
      case "upload-doc":
        payloadData = buildStoreDetailsPayload({
          storeDetails:
            stepKey === "store-details" ? formData : userPayload.storeDetails,
          uploadedDocs:
            stepKey === "upload-doc" ? formData : userPayload.uploadDocs,
          // serviceDetails: stepKey === "service_details" ? formData : userPayload.serviceDetails,
          store_id: userPayload?.storeDetails?.id,
          address_id: userPayload?.storeDetails?.address_id,
          latlong_id: userPayload?.storeDetails?.latlong_id,
        });
        break;
      case "bank-details":
        payloadData = buildBankDetailsPayload(formData);
        break;
      default:
        return;
    }

    axiosInstance
      .patch(`customer/users/${id}`, payloadData)
      .then(() => {
        if (stepKey === "upload-doc") {
          navigate(`/app/user-management`);
        } else {
          updateUser();
        }
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          showSnackbar(error?.response?.data?.message, "error");
        } else {
          showSnackbar("Something went wrong!", "error");
        }
        if (stepKey === "upload-doc") {
          setActiveStep(4);
          setActiveStepTitle("Upload Documents");
          handleProgress(100);
        }
      });
  };

  const createUser = (payload) => {
    let payloadData = {
      ...(payload.personal &&
        Object.keys(payload.personal).length > 0 &&
        buildPersonalInfoPayload(payload.personal)),
      ...buildStoreDetailsPayload({
        storeDetails: payload.storeDetails,
        uploadedDocs: payload.uploadDocs ?? [],
        // serviceDetails: payload.serviceDetails ?? [],
      }),
      ...(payload.bankDetails &&
        Object.keys(payload.bankDetails).length > 0 &&
        buildBankDetailsPayload(payload.bankDetails)),
      userType: "business user",
      isApproved: "approved",
      roles: [],
    };
    
    // axiosInstance
    //   .post("/customer/users", payloadData)
    //   .then((res) => {
    //     createService(res?.data?.stores[0]?.id);
    //   })
    //   .catch((error) => {
    //     if (error?.response?.data?.message) {
    //       showSnackbar(error?.response?.data?.message, "error");
    //     } else {
    //       showSnackbar("Something went wrong!", "error");
    //     }
    //   });
  };

  const createService = (storeId) => {
    if (servicePayload.length > 0) {
      const updatedPayload = servicePayload.map((item) => ({
        ...item,
        storeId: storeId,
      }));
      axiosInstance
        .post(`/customer/services-offered`, updatedPayload)
        .then(() => {
          navigate(`/app/user-management`);
        })
        .catch(() => {
          navigate(`/app/user-management`);
          showSnackbar(
            "user is created but omething went wrong while creating service!",
            "error"
          );
        });
    } else {
      navigate(`/app/user-management`);
    }
  };

  return (
    <div>
      {mode === "create" && (
        <div className="shadow-card py-7 px-3 mx-2 mb-5 rounded-full border border-[#e8e5e5]">
          <StepCard activeStep={activeStep} steps={steps} />
        </div>
      )}
      {mode === "edit" && (
        <div className="max-w-[800px] mx-2 mb-5">
          <ButtonNavigationBar
            activeStep={activeStep}
            steps={steps}
            handleSteps={stepHandler}
          />
        </div>
      )}
      {user === "admin" && (
        <div className="font-[500] text-[26px] mb-1 ml-3">
          {steps[activeStep]}
        </div>
      )}
      <div
        className={`form-container p-2 ${
          mode === "edit" ? "h-[calc(100vh-265px)]" : "h-[calc(100vh-290px)]"
        }`}
      >
        {activeStepTitle === "Owner" && (
          <PersonalInformation
            nextHandler={handleNext}
            profileType={"bussiness"}
            cancelHandler={handlePrevious}
            mode={mode}
            formValues={userPayload.personal}
          />
        )}
        {activeStepTitle === "Store Details" && (
          <StoreDetails
            nextHandler={handleNext}
            previousHandler={handlePrevious}
            mode={mode}
            formValues={userPayload.storeDetails}
          />
        )}
        {activeStepTitle === "Services Offered" && (
          <ServicesOffered
            nextHandler={handleNext}
            updatePayload={(service) => setServicePayload(service)}
            previousHandler={handlePrevious}
            mode={mode}
            services={{ tableData: userPayload.serviceDetails, servicePayload }}
            storeId={userPayload?.storeDetails?.id}
          />
        )}
        {activeStepTitle === "Bank Details" && (
          <AccountDetails
            nextHandler={handleNext}
            previousHandler={handlePrevious}
            mode={mode}
            formValues={userPayload.bankDetails}
          />
        )}
        {activeStepTitle === "Upload Documents" && (
          <UploadDocument
            nextHandler={handleNext}
            mode={mode}
            uploadedDocs={userPayload.uploadDocs}
            previousHandler={handlePrevious}
          />
        )}
      </div>
    </div>
  );
}

export default StoreManagement;
